var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoursePlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 81C63.092 81 81 63.092 81 41C81 18.908 63.092 1 41 1C18.908 1 1 18.908 1 41C1 63.092 18.908 81 41 81Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41.0005V27.1445L45 34.0725L57 41.0005L45 47.9285L33 54.8565V41.0005Z",
    fill: "#003C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePlayIcon);
export default __webpack_public_path__ + "static/media/coursePlayIcon.97d79e2c72178fc7b0f2b325f578d3c5.svg";
export { ForwardRef as ReactComponent };